import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'badges', 'Badges', [["path",{"d":"M17 17v-4l-5 3l-5 -3v4l5 3l5 -3"}],["path",{"d":"M17 8v-4l-5 3l-5 -3v4l5 3l5 -3"}]]);